import React from 'react';
import { useSettingsContext } from '@ldp/common-contexts';
import { SDMLanguageType } from '@ldp/common-types';
import { ViewResolverSdmInner, ViewResolverSection } from '../../components';
import { TViewDefinition } from '../../utils/view-resolver-utils';
import { MenuTileCarouselSkeleton } from '@ldp-web/component-library/ui/skeletons/menu-tile-carousel-skeleton';
import { useConfig } from '../../hooks';

interface ISearchColdStartComponentProps {
  data: TViewDefinition | null | undefined;
  isLoading: boolean;
}

export const SearchColdStartComponent = (props: ISearchColdStartComponentProps) => {
  const { data, isLoading } = props;
  const settings = useSettingsContext();
  const env = settings.env;
  const config = useConfig(env);
  const locale = settings.locale as SDMLanguageType;

  if (!data || !config) {
    return null;
  }

  return (
    <>
      {isLoading ? (
        <div>
          <MenuTileCarouselSkeleton />
          <MenuTileCarouselSkeleton />
          <MenuTileCarouselSkeleton />
        </div>
      ) : (
        <ViewResolverSdmInner
          apiKey={config?.apiKey}
          sduiBaseUrl={config?.sduiBaseUrl}
          locale={locale}
          pageId={'search-coldstart'}
          PageLoadingFallback={() => (
            <div>
              <MenuTileCarouselSkeleton />
              <MenuTileCarouselSkeleton />
              <MenuTileCarouselSkeleton />
            </div>
          )}
          queryConfig={{
            initialData: data as TViewDefinition,
            staleTime: Infinity,
          }}
        >
          <ViewResolverSection apiVersion={'v2'} layoutSection="mainContentCollection" />
        </ViewResolverSdmInner>
      )}
    </>
  );
};
